import classNames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import { PointsRequired } from '@/components/pay_ui/PointsVisible';
import { cn } from '@/utils/tw_common';
import i18n from '@/locales/init'; 
import { useModulePoints } from '@/hooks/useModulePoints';
import { CloseSvg } from '../../Svg';
import { checkHasPoints } from '../Points/userPoints';
import style from './index.module.less';

const pointsMap = {
  r: 70,
  l: 69,
  w: 71,
};

interface propsTypes {
  course: 'r' | 'l' | 'w';
  show: boolean;
  cancel: () => void;
  submitHandle: (val:()=>void) => void;
}
export default function FinishDialog(props: propsTypes ) {
  const {show, cancel, submitHandle, course} = props;
 
  const pointsInfo = useModulePoints(pointsMap[course] || 0);
  
  const okHandle = useMemoizedFn(() => {
    submitHandle(cancel);
  });
  
  return (
    <div className={style.mask} style={{display: show ? 'block' : 'none'}}>
      <div className={style.dialog}>
        <div className={style.titleBox}>
          <span className={style.title}>Finish test</span>
          <span className={style.close} onClick={cancel}>{CloseSvg}</span>
        </div>
        <div className={style.content}>
          <div className={classNames(style.text, style.firstText)}>{i18n.t('common.dauyan_exam_cannot_submit_advance')}</div>
          <div className={style.text}> </div>
          <div className={style.text}>{i18n.t('common.dauyan_save_prepare_time')}</div>
          <div className={style.text}>{i18n.t('common.dauyan_doing_mock_test')}</div>
          <div className={style.text}>{i18n.t('common.dauyan_exam_can_submit_advance')}</div>
        </div>
        <div className={style.bottom}>
          <div className={style.canel} onClick={cancel}>{i18n.t('common.dauyan_check_again')}</div>
          <div className={cn(style.confirm, pointsInfo.needCheckPoints ? 'flex justify-between w-[170px] px-[12px]' : '') } onClick={okHandle}>
            <div>
              {i18n.t('common.dauyan_confirm_handin_paper')}
            </div>
            {
              pointsInfo.needCheckPoints ? <div><PointsRequired size='18' fontStyle={{ fontSize: '12px' }} requiredPoints={pointsInfo.modulePoints} /></div> : null
            }
          </div>
        </div>
      </div>
    </div>
  );
}